import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface ICrudOperations<T, ID> {
  FindOne(id: ID): Observable<T>;
  FindAll(): Observable<T[]>;
  Save(t: T): Observable<T> | null;
  Update(id: ID, t: T): Observable<T>;
  Delete(id: ID): Observable<any> | null;
  Get4Select(): Observable<any[]>;
}

// @Injectable()
export abstract class CrudGenericsService<T, ID> implements ICrudOperations<T, ID> {
  constructor(protected _http: HttpClient, protected _base: string) {}
  FindOne(id: ID): Observable<T> {
    return this._http.get<T>(`${this._base}/${id}`);
  }

  FindAll(): Observable<T[]> {
    return this._http.get<T[]>(this._base);
  }

  Save(t: T): Observable<T> | null {
    return this._http.post<T>(this._base, t);
  }

  Update(id: ID, t: T): Observable<T> {
    return this._http.put<T>(`${this._base}/${id}`, t);
  }

  Delete(id: ID): Observable<any> | null {
    return this._http.delete<any>(`${this._base}/${id}`);
  }
  Get4Select(): Observable<any[]> {
    return this._http.get<any[]>(`${this._base}/Get4Select`);
  }
}
